// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringMustBeNumber } from 'validators/common/simple'
import { MUST_BE_LESS_THAN_OR_EQUAL_ZERO } from 'errors'

// X <= 0
const stringMustBeLessThanOrEqualZero = v => (
  stringMustBeNumber(v) ||
  v.length && !(+v <= 0) && MUST_BE_LESS_THAN_OR_EQUAL_ZERO
)

export default stringMustBeLessThanOrEqualZero
